import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Stack,
} from '@mui/material';

import Lightbox from 'lightbox-react';

import useFlirtMedia from 'app/hooks/useFlirtMedia';

const PreviewableAttachments = ({ attachments }) => {
  const previewableMediaItems = useMemo(
    () => attachments.filter(attachment => attachment.previewable),
    [attachments],
  );

  const iframeMediaItems = useMemo(
    () => previewableMediaItems.map((mediaItem) => ({
      id: mediaItem.id,
      node: (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          <iframe
            key={mediaItem.id}
            title={mediaItem.filename}
            src={mediaItem.fmUrl}
            style={{
              border: 'none',
              // Let iframe fill container
              width: '100%',
              height: '100%',
              // Center iframe content
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          />
        </Box>
      ),
    })),
    [previewableMediaItems],
  );

  const {
    nextItem,
    prevItem,
    currentItem,
    onPrevClick,
    onNextClick,
    onCloseClick,
    setMediaIndex,
    lightboxIsOpen,
    setLightboxIsOpen,
  } = useFlirtMedia({ mediaItems: iframeMediaItems });

  const onAttachmentClick = (messageAttachment) => {
    if (messageAttachment.previewable) {
      const index = iframeMediaItems.findIndex(item => item.id === messageAttachment.id);
      setMediaIndex(index);
      setLightboxIsOpen(true);
    }
  };

  return (
    <>
      {lightboxIsOpen && (
        <Lightbox
          enableZoom={false}
          mainSrc={currentItem.node}
          // We set next and prev to the IDs so when we scroll, we lazy load the item. If we don't do this, the lightbox will load all the items at once.
          // Loading them all at once will cause FM to download the files to FM n number of times where n is the number of previewable attachments.
          nextSrc={nextItem?.id}
          prevSrc={prevItem?.id}
          onCloseRequest={onCloseClick}
          onMovePrevRequest={onPrevClick}
          onMoveNextRequest={onNextClick}
          imageCaption={currentItem.node.title}
        />
      )}
      {attachments.map((attachment) => (
        <Stack
          key={attachment.id}
          direction="row"
        >
          <Box onClick={() => onAttachmentClick(attachment)}>
            <a href={attachment.previewable ? null : attachment.mainUrl} target="_blank" rel="noopener noreferrer">
              <img src={attachment.icon_url} alt={attachment.filename} />
            </a>
            <Box key={attachment.id}>
              {attachment.filename}
            </Box>
            <Box>
              {attachment.sizeString}
            </Box>
          </Box>
        </Stack>
      ))}
    </>
  );
};

PreviewableAttachments.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PreviewableAttachments;
